<template>
  <div id="type_indicator" class="typingIndicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: 'TypeIndicator'
}
</script>
